import { Component, OnInit } from '@angular/core';

// Ck Editer
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
	selector: 'app-add-product',
	templateUrl: './add-product.component.html',
	styleUrls: ['./add-product.component.scss'],
})

/**
 * AddProduct Component
 */
export class AddProductComponent implements OnInit {
	// bread crumb items
	breadCrumbItems!: Array<{}>;
	public Editor = ClassicEditor;

	constructor() {}

	ngOnInit(): void {
		/**
		 * BreadCrumb
		 */
		this.breadCrumbItems = [
			{ label: 'Ecommerce' },
			{ label: 'Create Product', active: true },
		];
	}

	/**
	 * Multiple Default Select2
	 */
	selectValue = ['Choice 1', 'Choice 2', 'Choice 3'];
}
